module.exports = __webpack_public_path__ + "static/media/friend-amatue.3e927fd3.jpg";